<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: luoyi | luoyanzhen
 * @LastEditTime: 2024-08-28 16:01:51
-->
<template>
  <div class="container">
    <nav-bar :active.sync="active"></nav-bar>
    <components @dateUp="dateUp" :is="comps[active]"></components>
  </div>
</template>
<script>
import navBar from './components/navBar'
import homePage from './homePage'
import myList from './myList'
import grabATicket from './grabATicket'
import { getToken, removeLocalStorage } from '@utils'
export default {
  components: {
    navBar,
    myList,
    grabATicket,
    homePage
  },
  data() {
    return {
      active: 0,
      comps: ['homePage', 'grabATicket', 'myList']
    }
  },
  created() {
    if (getToken()) {
      this.active = 0
    }
  },
  methods: {
    dateUp(e) {
      console.log(e)
      this.$nextTick(() => {
        this.active = e
      })
    }
  },
  destroyed() {
    removeLocalStorage('couponsId')
  }
}
</script>
